import React from 'react'
import { ResourceCard } from './ResourceCard'
import {
  mapWatsonResultToCardProps,
  mapCMSResultToCardProps
} from './mapResultToCardProps'
import { SkeletonLoader } from '@ampcore/design-system'
import { ResourceResultItem } from '@ampcore/client-side-services'

type ResourceCardGridProps = {
  results: ResourceResultItem[]
  isWatsonSearch: boolean
  isFilters: boolean
  isLoading: boolean
  totalSize: number | null
}

const ResourceCardGrid: React.FC<ResourceCardGridProps> = ({
  results,
  isWatsonSearch,
  isFilters,
  isLoading,
  totalSize
}) => {
  const getSkeletonCount = () => {
    const batchSize = isFilters ? 4 : 6

    if (totalSize == null || results.length === 0) {
      return batchSize
    }

    const remaining = totalSize - results.length
    return Math.min(batchSize, remaining)
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const toCardProps = (result: any) =>
    isWatsonSearch
      ? mapWatsonResultToCardProps(result)
      : mapCMSResultToCardProps(result)

  const columnClassName = `u-sm-sizeFull u-size1of${
    isFilters ? '2' : '3'
  } u-marginBottom24`

  return (
    <div className={`${isLoading && 'u-paddingBottom16'}`}>
      {totalSize == null && (
        <div className="u-marginBottom16">
          <SkeletonLoader width="80%" height="20px" />
        </div>
      )}
      <div className="Grid Grid--withGutter">
        {results.map((result, index) => {
          const cardProps = toCardProps(result)
          const resultRecord = result as unknown as Record<string, unknown>
          const key = isWatsonSearch
            ? `${String(
              resultRecord.url ?? resultRecord.title ?? 'watson-result'
            )}-${index}`
            : (resultRecord._meta as { id: string }).id
          return (
            <div key={key} className={columnClassName}>
              <ResourceCard {...cardProps} />
            </div>
          )
        })}
        {isLoading &&
          Array.from({ length: getSkeletonCount() }).map((_, i) => (
            <div key={i} className={columnClassName}>
              <SkeletonLoader width="100%" height="200px" />
            </div>
          ))}
      </div>
    </div>
  )
}

export default ResourceCardGrid
